import { CreditCalculationStructure, CreditStructure } from './credit-structure.model'

/** Linked with one to many `CreditStructureGroupMember` structures */
export interface CreditStructureGroup {
  id?: number
  program_id: number
  label: string
  credit_calculation_structure_id: string
  checked?: boolean
}

/** Child of `CreditStructureGroup` */
export interface CreditStructureGroupMember {
  id?: number
  credit_structure_group_id: number
  credit_structure_id: number
  ordinal: number
}

/** To track the structure group viewable on the tower */
export interface CreditStructureGroupEntity {
  creditStructureGroup: CreditStructureGroup
  creditCalculationStructure: CreditCalculationStructure /* store the structure group in mongo as a calculation structure */
}

/** To track which structure members make up the group tower */
export interface CreditStructureGroupMemberEntity {
  creditStructureGroupMember: CreditStructureGroupMember
  creditStructure: CreditStructure
  creditCalculationStructure: CreditCalculationStructure
}
